import React, { forwardRef, useEffect, useState, useMemo, useCallback, useRef } from 'react'
import { Form, Tooltip } from 'antd';
import { FieldTypes } from 'utils/formUtils';
import BaseModalForm from 'components/BaseModalForm';
import { noop, isNull } from 'lodash';
import copy from 'copy-to-clipboard';
import message from "components/CustomMessage";
import ModalUtil from "utils/modalUtil";
import UserAPI from "restAPI/UserAPI";
import SavedSearchAPI from "restAPI/SavedSearchAPI";
import { ShareIcon } from "./Icons";
import { CopyOutlined } from '@ant-design/icons';

export const ShareIt = () => {
    const showShareablePopup = () => {
        ModalUtil.show({
            content: <SharablePopUp
                searchText={window?.location?.href}
            />
        })
    }
    return <>
            <Tooltip title="Share this search by emailing other user">
                <ShareIcon className="clickable" onClick={showShareablePopup} />
            </Tooltip>
        </>
}


export const SharablePopUp = forwardRef(({ searchText = window.location.href, afterClose = noop }, ref) => {
    const [users, setUsers] = useState(null);
    const [form] = Form.useForm();
    const messageRef = useRef();

    const copyTextToClipBoard = useCallback(() => {
        if (messageRef.current) {
            messageRef.current();
        }
        copy(searchText);
        messageRef.current = message.success('Link copied to clipboard');
    }, [searchText])

    useEffect(() => {
        copyTextToClipBoard();
    }, [copyTextToClipBoard]);

    useEffect(() => {
        const {promise, cancel} = UserAPI.getAll();
        promise.then(
            setUsers,
            e => console.error(e)
        );
        return cancel;
    }, []);

    const handleOnOk = async (data) => {
        await SavedSearchAPI.shareFilterLink({
            url: data.search,
            userIds: data.users,
            note: data.note,
        });
        message.success('Search shared with the selected users.');
    };

    const copyIcon = useMemo(() => {
        return (
            <Tooltip title={'Copy Link'}>
                <CopyOutlined onClick={copyTextToClipBoard} />
            </Tooltip>
        );
    }, [copyTextToClipBoard]);

    const fields = useMemo(() => [
        {
            name: "search",
            label: "Link to search",
            disabled: true,
            required: true,
            NoDefaultLengthRule: true,
            props: {
                addonAfter: copyIcon
            }
        },
        {
            name: "users",
            label: 'Users',
            loading: isNull(users),
            type: FieldTypes.MULTI_SELECT,
            options: users,
            required: true,
            help: 'Select users, with whom the search will be shared.'
        },
        {
            name: "note",
            label: 'Note',
            type: FieldTypes.TEXT_AREA
        },
    ], [users, copyIcon]);

    const modalProps = {
        title: <>Share</>,
        okText: "Share",
    };

    return (
        <BaseModalForm
            modalProps={modalProps}
            fields={fields}
            ref={ref}
            afterClose={afterClose}
            form={form}
            onOk={handleOnOk}
            initialValues={{
                search: searchText
            }}
        />
    )
})
